﻿<script>
	import uuid4 from "uuid4";
	import Trade from "./Trade.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import FormRow from "../../../components/FormRow.svelte";
	import { formatDate } from "../../../helpers/dateHelpers";
	import HoldingTransaction from "../../../models/HoldingTransaction";

	export let id = uuid4().substring(0, 3);
	export let required = null;
	export let disabled = null;
	export let tradeDataArray = [];
	export let isInitialPublicOffer = null;
	export let minPrice = 0;
	export let maxPrice = null;

	const removeEntry = (item, index) => {
		item.DateDeleted = formatDate(new Date());
		item.DeletedBy = "Registration";

		tradeDataArray = [...tradeDataArray]; // trigger reactivity
	};

	const addEntry = () => {
		tradeDataArray = [...tradeDataArray, new HoldingTransaction()];
	};
</script>

{#if !disabled}
	<FormRow>
		<FormColumn>
			<button class="btn btn-primary btn-sm" title={`Add Transaction`} on:click|preventDefault={() => addEntry()}
				>Add Transaction</button
			>
		</FormColumn>
	</FormRow>
{/if}

{#each tradeDataArray as tradeData, i}
	{#if !tradeData.DateDeleted}
		<Trade
			id={`${id}_${i}`}
			rowIndex={i}
			{required}
			{disabled}
			{isInitialPublicOffer}
			{minPrice}
			{maxPrice}
			bind:transactionDate={tradeData.TransactionDate}
			bind:transactionType={tradeData.TransactionType}
			bind:numberOfShares={tradeData.NumberOfShares}
			bind:pricePerShare={tradeData.PricePerShare}
			bind:brokerage={tradeData.Brokerage}
			handleRemoveRow={() => removeEntry(tradeDataArray[i], i)}
		></Trade>
	{/if}
{/each}
